import { Link, useLocation } from "react-router-dom";
import styles from "../../styles/Components/header/HeaderNavigationMenu.module.css";
import { FiActivity, FiBarChart2, FiEye, FiSettings } from "react-icons/fi";
import { SiTestcafe } from "react-icons/si";
import { TbReport } from "react-icons/tb";
import { MdSubscriptions } from "react-icons/md";
import { PiListChecksFill } from "react-icons/pi";
import { HiMiniGiftTop } from "react-icons/hi2";

const botMenuItems = [
  {
    label: "Configuration",
    path: "/bot-automation",
    icon: <FiSettings size={20} />,
  },
  {
    label: "Backtests",
    path: "/bot-automation/backtest",
    icon: <SiTestcafe size={23} />,
  },
  {
    label: "Performance",
    path: "/bot-automation/bot-performance",
    icon: <TbReport size={21} />,
  },
];

// const alertSystemMenu = [
//   {
//     label: "Alert System",
//     path: "/alert-system",
//     icon: <AiFillAlert size={22} />,
//   },
//   {
//     label: "Custom Strategy Alerts",
//     path: "/alert-system/strategy-alerts",
//     icon: <BiSolidCustomize size={20} />,
//   },
//   {
//     label: "Emails",
//     path: "/alert-system/previous-emails",
//     icon: <AiOutlineMail size={22} />,
//   },
// ];

const insightsMenu = [
  {
    label: "Signal",
    path: "/insight/signal",
    icon: <FiActivity />,
  },
  {
    label: "Chart",
    path: "/insight/chart",
    icon: <FiBarChart2 />,
  },
  {
    label: "Watchlist",
    path: "/insight/watchlist",
    icon: <FiEye />,
  },
];

const pricingMenu = [
  {
    label: "Subscriptions",
    path: "/pricing-billing/subscription",
    icon: <MdSubscriptions />,
  },
  {
    label: "Custom Services",
    path: "/pricing-billing/activate-services",
    icon: <PiListChecksFill />,
  },
  {
    label: "Referral Earnings",
    path: "/pricing-billing/referrals",
    icon: <HiMiniGiftTop />,
  },
];

function HeaderNavigationMenu() {
  const { pathname } = useLocation();
  const isInHelpSection = pathname?.includes("faq");

  if (isInHelpSection) return null;

  return (
    <ul className={styles.menu}>
      {pathname?.split("/")?.[1] === "pricing-billing"
        ? pricingMenu.map((item, index) => (
            <li
              className={`${styles.menuItem}  ${
                pathname === item.path ||
                (index === 0 && pathname === "/pricing-billing")
                  ? styles.active
                  : ""
              }`}
              key={item.label}
            >
              <Link to={item.path}>
                {item.icon}
                {item.label}
              </Link>
            </li>
          ))
        : null}

      {/*{pathname.includes("bot-automation") &&*/}
      {/*  botMenuItems.map((item) => (*/}
      {/*    <li*/}
      {/*      className={`${styles.menuItem}  ${*/}
      {/*        pathname === item.path ? styles.active : ""*/}
      {/*      }`}*/}
      {/*      key={item.label}*/}
      {/*    >*/}
      {/*      <Link to={item.path}>*/}
      {/*        {item.icon}*/}
      {/*        {item.label}*/}
      {/*      </Link>*/}
      {/*    </li>*/}
      {/*  ))}*/}

      {/*{pathname.includes("alert-system") &&*/}
      {/*  alertSystemMenu.map((item) => (*/}
      {/*    <li*/}
      {/*      className={`${styles.menuItem}  ${*/}
      {/*        pathname === item.path ? styles.active : ""*/}
      {/*      }`}*/}
      {/*      key={item.label}*/}
      {/*    >*/}
      {/*      <Link to={item.path}>*/}
      {/*        {item.icon}*/}
      {/*        {item.label}*/}
      {/*      </Link>*/}
      {/*    </li>*/}
      {/*  ))}*/}

      {pathname.includes("insight") &&
        insightsMenu.map((item) => (
          <li
            className={`${styles.menuItem}  ${
              pathname === item.path ? styles.active : ""
            } ${item.label === "Signal" && pathname === "/insight" ? styles.active : ""}`}
            key={item.label}
          >
            <Link to={item.path}>
              {item.icon}
              {item.label}
            </Link>
          </li>
        ))}
    </ul>
  );
}

export default HeaderNavigationMenu;
